
import "./PrivacyComponent.css";

const PrivacyComponent = () => {
    return (
      <div className="aboutUsBlock">
        <div className="aboutus-hero-banner">
          <div className="container">
            <h1>Privacy Policy</h1>
          </div>
        </div>
        <div className="layout">
          <aside className="sidebar">
            <h2>On this page</h2>
            <nav>
              <ul>
                <li><a href="#interpretation">Interpretation</a></li>
                <li><a href="#collecting">Collecting Data</a></li>
                <li><a href="#usage">Using Data</a></li>
                <li><a href="#security">Links to Other Websites</a></li>
                <li><a href="#changes">Policy Changes</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </nav>
          </aside>
          <main className="main-content">
            <div className="top-section">
              <p className="last-updated">Last updated: January 21, 2025</p>
              <p className="intro">
                At <strong>IAmInterviewed</strong>, we value your privacy. This policy explains what data we collect, how we use it, and how we safeguard your information.
              </p>
              <p className="intro">
                This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
              </p>
              <p className="intro">
                We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy incorporates details as per current legal and platform standards.
              </p>
            </div>
            <article id="interpretation" className="policy-section">
              <h2 className="section-title">Interpretation and Definitions</h2>
              <p>Words with initial capital letters have meanings defined under the following conditions.</p>
              <ul>
                <li><strong>Account:</strong> A unique account created for You to access our Service or parts of our Service.</li>
                <li><strong>Company:</strong> Refers to IAmInterviewed, 10 M 226, 100 Ft Road, HRBR Layout, Block 1, Kalyan Nagar, Bangalore - 560043, Karnataka, India.</li>
                <li><strong>Device:</strong> Any device that can access the Service such as a computer, cellphone, or tablet.</li>
                <li><strong>Website:</strong> <a href="https://www.iaminterviewed.com">www.iaminterviewed.com</a></li>
                <li><strong>Personal Data:</strong> Any information relating to an identified or identifiable individual.</li>
                <li><strong>Service:</strong> The IAmInterviewed website and platform.</li>
                <li><strong>Service Provider:</strong> Any person or legal entity processing data on behalf of the Company (including third-party services used to facilitate our Service).</li>
                <li><strong>Usage Data:</strong> Data collected automatically, generated by the use of the Service or from infrastructure itself (e.g., page visit duration).</li>
                <li><strong>Cookies:</strong> Small files placed on your device by our website, containing details of your browsing history among its many uses.</li>
              </ul>
            </article>
            <article id="collecting" className="policy-section">
              <h2 className="section-title">Collecting and Using Your Data</h2>
              <p>We may collect the following information:</p>
              <ul>
                <li>Email address, first and last name, and contact details</li>
                <li>Phone number</li>
                <li>Usage data, such as pages visited, time spent, browser information, device identifiers, and diagnostic data</li>
                <li>IP address and related technical information</li>
                <li>Data from cookies and similar tracking technologies (see Cookies Policy for complete information)</li>
              </ul>
            </article>
            <article id="usage" className="policy-section">
              <h2 className="section-title">How We Use Your Data</h2>
              <p>Your personal data is used for:</p>
              <ul>
                <li>Providing, maintaining, and improving our services</li>
                <li>Managing your registration and account</li>
                <li>Fulfilling contracts and transactions for our services</li>
                <li>Communicating with you by email, calls, SMS, or app notifications</li>
                <li>Providing you with relevant news, special offers, or information about our goods/services (unless you opt out)</li>
                <li>Handling your requests</li>
                <li>Security monitoring and service optimization</li>
                <li>Business transfers and analysis (including mergers/acquisitions, if applicable)</li>
                <li>Legal requirements and compliance</li>
              </ul>
              <p>Your data may also be used for analytics, trend analysis, marketing effectiveness, and overall experience improvements.</p>
            </article>

            <article id="sharing" className="policy-section">
              <h2 className="section-title">Sharing Your Data</h2>
              <p>We may share your personal information in the following situations:</p>
              <ul>
                <li>With Service Providers (e.g. analytics, communication, and support tools)</li>
                <li>During business transfers, mergers, or asset sales, with prior notice</li>
                <li>With affiliates, under common control and subject to this Privacy Policy</li>
                <li>With business partners to offer products, services, or promotions</li>
                <li>With other users in public areas (such as forums or reviews)</li>
                <li>If required by law, government requests, or to protect company or public rights</li>
                <li>With your consent, for any other purposes you approve</li>
              </ul>
            </article>

            <article id="retention" className="policy-section">
              <h2 className="section-title">Retention of Your Data</h2>
              <p>
                We retain personal data only as long as necessary to fulfill the purposes outlined in this policy—including legal, analytical, security, and service improvement uses. Usage data is usually retained for a shorter period, except when needed for legal obligations or to improve platform security and functionality.
              </p>
            </article>

            <article id="security" className="policy-section">
              <h2 className="section-title">Security of Your Data</h2>
              <p>
                We employ commercially acceptable security measures (including session controls and necessary cookies) to protect your information, but no online method is 100% secure. You can control cookie acceptance in your browser, but doing so may limit some service features.
              </p>
            </article>

            <article id="links" className="policy-section">
              <h2 className="section-title">Links to Other Websites</h2>
              <p>
                Our service may contain links to external websites not operated by us. We advise reviewing each site's privacy policy; we are not responsible for the privacy practices of third parties.
              </p>
            </article>

            <article id="changes" className="policy-section">
              <h2 className="section-title">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy occasionally. Notice of changes will be posted here, and the revision date will be updated. Significant changes may be communicated via email or a prominent notice on our platform.
              </p>
            </article>

            <article id="contact" className="policy-section">
              <h2 className="section-title">Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, you can contact us:
              </p>
              <ul>
                <li><strong>Email:</strong> info@iaminterviewed.com</li>
                <li><strong>Address:</strong> IAmInterviewed, 10 M 226, 100 Ft Road, HRBR Layout, Block 1, Kalyan Nagar, Bangalore - 560043, Karnataka, India</li>
              </ul>
            </article>
          </main>
        </div>
      </div>
    );
};
export default PrivacyComponent;